// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.profile-grid[data-v-e9839066] {\n    display: grid;\n    grid-template-columns: max-content auto;\n    grid-column-gap: 40px;\n    grid-row-gap: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
